import { render, staticRenderFns } from "./ClinicTexts.vue?vue&type=template&id=73f15efa&"
import script from "./ClinicTexts.vue?vue&type=script&lang=js&"
export * from "./ClinicTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports